import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {  Grid  } from "semantic-ui-react";
import InputField from "../../../../commonComponents/formComponents/inputField";
import { updateTransportationHeaderInfo } from "../../../actions";
import DropDown from "../../../../commonComponents/formComponents/dropDown";
import { useCurrentShipmentType } from "../../../../hooks/useCurrentShipmentType";
import { Country } from "../../../../commonComponents/dropdown/country";
import { selectCountryList010 } from "../../../selectors";
import { TranslateContext } from "../../TranslateContext";
import { SearchPort } from "../../../../commonComponents/dropdown/Ports";
import { useSelectDestCntryByDeclaration } from "../../../hooks/useSelectDestCntryByDeclaration";
import { destCountryKey } from "../../../util/NL_fieldPatterns";

const HeaderInfo=({fieldPattern,validateError,saveForm})=>{
  const dispatch=useDispatch()
  const { isImportShipment,isDMS } = useCurrentShipmentType();
  const modeOfTransportList = useSelector((state) => state.DropDownValues.modeOfTransportList);
  const countryList010 = useSelector(selectCountryList010);
  const destCountryError=useSelector((state)=>state.ValidationErrors.header?.[destCountryKey]?.msg)
  const {placeOfLoading,percentFreight,exportCountry,destinationCountry,terminal,placeOfUnloading} = useSelector((state) => state.Shipment.transportation);
  const destinationCountryList=useSelectDestCntryByDeclaration(isImportShipment,destinationCountry,saveForm)
  
  const saveData=(params)=>saveForm({transportation:params})
  const translate = React.useContext(TranslateContext).translate
  
 return (
    <React.Fragment>
         <Grid.Row>
          <Grid.Column width="4" className="divFormFeild">
          <Country
                 id="exportCountry"
                 label={translate("COUNTRY_OF_EXPORT")}
                 dataSource={countryList010}
                 className="field-bg dropdown100"
                 clearable
                 value={exportCountry}
                onChange={(value) =>{
                  saveData({exportCountry:value,placeOfLoading:" "})
                  dispatch(updateTransportationHeaderInfo({exportCountry:value,placeOfLoading:""}))} 
                }   
               
              />
          
           
          </Grid.Column>
          <Grid.Column width="4" className="divFormFeild">
          <SearchPort
              id="loadingPlace"
              condition={exportCountry}
              label={translate("PORT_OF_LADING", { ns: ["default", "header"] })}
              selectedValue={placeOfLoading}
              className="field-bg"
              boxNumber="5/21"
              onSelect={({ portUnloc }) => {
                dispatch(updateTransportationHeaderInfo({placeOfLoading:portUnloc}))
                saveData({placeOfLoading:portUnloc})
              }}
              onBlur={({value})=>{
                dispatch(updateTransportationHeaderInfo({placeOfLoading:value}))
                saveData({placeOfLoading:value || " "})
              }}
              ></SearchPort>
          
         
          </Grid.Column>
        {
          isImportShipment && <Grid.Column width="4" className="divFormFeild">
            <InputField
              isLabel={false}
              id="percentFreight"
              type="number"
              mandatory={false}
              label={translate("PERCENT_AIRFREIGHT", {ns:["default","header"]})}
              value={percentFreight}
              className="field-bg"
              clearInput={false}
              onChange={(value) =>dispatch(updateTransportationHeaderInfo({percentFreight:value}))}    
              onBlur={(value) =>saveData({percentFreight})
               }
             
            />
          </Grid.Column>
}
          
             
             <Grid.Column width={isImportShipment ? "4" :"8"} className="divFormFeild">
           <Country
                 id="destinationCountry"
                 errors={destCountryError}
                 label={translate("COUNTRY_OF_DESTINATION", {ns:["default", "header"]})}
                 dataSource={destinationCountryList}
                 className="field-bg dropdown100"
                 value={destinationCountry}
                 clearable
                 onChange={(value) =>{
                  saveData({destinationCountry:value,placeOfUnloading:" "})
                  dispatch(updateTransportationHeaderInfo({destinationCountry:value,placeOfUnloading:""}))
                  validateError({[`${destCountryKey}`]:""},{transportation:{destinationCountry:value?.trim()}},{[destCountryKey]:fieldPattern()?.header[destCountryKey]})
                }  
                    
                
                }
               
              />
         
           
          </Grid.Column>
          
        
    
        </Grid.Row>
        <Grid.Row>
          <Grid.Column
            width="5"
            className="divFormFeild"
          >
            <SearchPort
              id="unLoadingPlace"
              condition={destinationCountry}
              label={translate("PORT_OF_UNLADING", { ns: ["default", "header"] })}
              selectedValue={placeOfUnloading}
              className="field-bg"
              boxNumber="5/22"
              onSelect={({ portUnloc }) => {
                dispatch(updateTransportationHeaderInfo({placeOfUnloading:portUnloc}))
                saveData({placeOfUnloading:portUnloc})
              }}
              onBlur={({value})=>{
                dispatch(updateTransportationHeaderInfo({placeOfUnloading:value}))
                saveData({placeOfUnloading:value || " "})
              }}
              />
          
          </Grid.Column>
          {isDMS && <Grid.Column width="5" className="divFormFeild">
            <DropDown
              id="terminal"
              label={translate("TERMINAL", {ns:["default", "header"]})}
              className="field-bg dropdown100"
              isLabel={true}
              clearable
              data={modeOfTransportList}
              value={terminal}
              onChange={(value) =>dispatch(updateTransportationHeaderInfo({terminal:value}))}    
              onBlur={(value) =>saveData({terminal})
              }
            />
            
          </Grid.Column>
}
          <Grid.Column width="6" className="divFormFeild">
          <InputField
              isLabel={false}
              id="carrierName"
              type="text"
              mandatory={false} 
              className="field-bg"
              clearInput={false}
              disabled={true}
           
            />
        
          
          </Grid.Column>
        </Grid.Row>
    </React.Fragment>
  );
}

export default React.memo(HeaderInfo)
